module.exports = __webpack_public_path__ + "static/media/6.da64d050.JPG";